// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Portfolio_wrapper__3VanS","dropdownNote":"Portfolio_dropdownNote__204xW","portfolioWrapper":"Portfolio_portfolioWrapper__10Qn7"};